import type { GenerationJob } from "../types";

const PHASES = [
  ["Разбираем тему", "Вопрос и контекст"],
  ["Строим план", "Последовательность рассказа"],
  ["Проверяем факты", "Источники и детали"],
  ["Пишем текст", "От первого абзаца до финала"],
  ["Проверяем результат", "Текст и оформление"],
] as const;

export function generationSteps(job: Pick<GenerationJob, "status" | "phase" | "phaseDetail" | "settings">) {
  const phase = Math.min(4, Math.max(0, job.phase));
  return PHASES.map(([title, detail], index) => {
    const offlineCheck = index === 2 && !job.settings.webResearch;
    const state = job.status === "queued" ? "pending"
      : job.status === "completed" || index < phase ? "complete"
      : index > phase ? "pending" : job.status === "failed" ? "failed"
      : job.status === "cancelled" ? "cancelled" : "active";
    return { title: offlineCheck ? "Проверяем детали" : title, state,
      detail: state === "active" ? job.phaseDetail || detail : offlineCheck ? "Последовательность событий, без веб-поиска" : detail };
  });
}
